import React from "react";
import { useParams } from "react-router-dom";
import PageEditorV2 from "./PageEditorV2";

function PageEditorV2Page() {
  const { id } = useParams<{ id?: string }>();
  
  return (
    <div className="w-full h-full">
      <PageEditorV2 blockId={id} />
    </div>
  );
}

export default PageEditorV2Page;

